import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setDependents = info =>
  call(websocketFetch, 'admin_set_dependents', info);
